import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CommonFlex, CommonGrid, PageTitle } from '../../styledComponents/common';
import ItemsCountingReportFilterContainer from './Filter/ItemsCountingReportFilterContainer';
import ItemsCountingReportList from './ItemsCountingReportList';
import { ButtonIcon, WhiteButtonWithIcon } from 'styledComponents/buttons';
import ButtonTextLoader from 'components/Loaders/ButtonTextLoader';
import excelIcon from '../../assets/img/icons/excel-green.svg';

const ItemsCountingReport = ({
  itemsCountingReport = [],
  isLoading,
  reportLoading,
  sendExportExcelRequest
}) => {
  const { t } = useTranslation();
  const [selectedParams, setSelectedParams] = useState({});

  const handleExportToExcel = () => {
    sendExportExcelRequest(selectedParams, 'counting-sub-tasks');
  };

  return (
    <div className="content">
      <CommonGrid alignItem="center">
        <PageTitle>{t('items_counting_report')}</PageTitle>
        <CommonFlex gap="12px">
          {localStorage.getItem('user_role') !== 'employee' ? (
            <WhiteButtonWithIcon
              onClick={() => handleExportToExcel()}
              color="#19AC65"
              borderColor="#19AC65"
              hoverBorderColor="#129652"
              padding={reportLoading ? '0 45px' : '0 25px'}
            >
              {reportLoading ? (
                <ButtonTextLoader color="#19AC65" loadingText=" " size={6} />
              ) : (
                <>
                  <ButtonIcon src={excelIcon} size="26px" />
                  {t('export_report')}
                </>
              )}
            </WhiteButtonWithIcon>
          ) : null}
        </CommonFlex>
      </CommonGrid>
      <ItemsCountingReportFilterContainer
        setSelectedParams={setSelectedParams}
        selectedParams={selectedParams}
      />
      <ItemsCountingReportList
        isLoading={isLoading}
        itemsCountingReport={itemsCountingReport}
      />
    </div>
  );
};

export default ItemsCountingReport;
